<template>
    <navbar />
    <div class="page-box">
        <div class="box1">
            <div class="lf">
                <p class="ps" data-aos="fade-up">Invertí en Bolsa con MatrixQuant, agente y sociedad de bolsa líder en Argentina</p>
                <h1 class="sasi-heading__title" data-aos="fade-up" data-aos-delay="50"> La app donde tus ahorros <span class="blue">crecen</span></h1>
                <h4 class="msg" data-aos="fade-up" data-aos-delay="100">Invertí en Argentina y USA desde la misma cuenta.
                    Impulsamos tus inversiones a tráves de nuestra experiencia, tecnología y asesoramiento.</h4>
                <div class="list" data-aos="fade-up" data-aos-delay="150">
                    <div class="line">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <span>Sin montos mínimos</span>
                    </div>
                    <div class="line">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <span>Sin costo de apertura</span>
                    </div>
                    <div class="line">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <span>ARG-USA desde una cuenta</span>
                    </div>
                    <div class="line">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <span>Apertura en minutos</span>
                    </div>
                </div>
                <div class="btn-box" data-aos="fade-up" data-aos-delay="200">
                    <router-link class="btn" to="/BullMarketBrokers">Abrí tu cuenta</router-link>
                </div>
            </div>
            <div class="cuenta-de" >
                <img loading="lazy" data-aos="zoom-in" src="@/assets/images/cuenta-de.jpg" alt="">
            </div>
        </div>
        <div class="box2">
            <div class="content">
                <div class="sasi-heading">
                    <span class="sasi-heading__sub">Quienes somos</span>
                    <h1 class="sasi-heading__title">Somos tu Agente Fintech</h1>
                </div>
                <h4 class="msg">Somos Agente de Liquidación y Compensación
                    (ALyC N° 247) y Agente de Colocación y Distribución Integral (ACDI N° 28), regulado por la Comisión
                    Nacional de Valores.
                </h4>
                <div class="list">
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Accedé a los principales Mercados financieros </h3>
                    </div>
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Invertí con custodia de tus títulos valores </h3>
                    </div>
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Trazabilidad, control total y seguridad para tu cuenta </h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="con-inner">
            <h3 class="title">25 años impulsando tus inversiones</h3>
            <div class="list">
                <a href="http://www.cnv.gov.ar/" target="_blank" rel="nofollow">
                    <img loading="lazy" src="@/assets/images/footer-cnv-1.jpg" class="img" alt="">
                </a>
                <a href="https://www.sec.gov/" target="_blank" rel="nofollow">
                    <img loading="lazy" src="@/assets/images/footer-us-1.jpg" class="img" alt="">
                </a>
                <a href="https://bcra.gob.ar/" target="_blank" rel="nofollow">
                    <img loading="lazy" src="@/assets/images/footer-bcra-1.jpg" class="img" alt="">
                </a>
                <a href="https://www.argentina.gob.ar/superintendencia-de-seguros" target="_blank" rel="nofollow">
                    <img loading="lazy" src="@/assets/images/footer-ssn-1.jpg" class="img" alt="">
                </a>
                <a href="https://cajadevalores.com.ar/" target="_blank" rel="nofollow">
                    <img loading="lazy" src="@/assets/images/footer-valo-1.jpg" class="img" alt="">
                </a>
            </div>
        </div>
        <div class="con-inner paddinf-bottom">
            <div class="sasi-heading">
                <span class="sasi-heading__sub">En qué podés invertir</span>
                <h1 class="sasi-heading__title">Todo el mercado<br>al alcance de tu <span
                        class="blue">app<span></span></span></h1>
            </div>
            <h4 class="msg">Tu cuenta de inversión posee todos los activos y oportunidades disponibles de Argentina y
                Estados Unidos</h4>
            <div class="grid">
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid1.svg" alt=""></div>
                    <h3 class="box-title">
                        <span>Acciones <br>ARG </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid2.svg" alt=""></div>
                    <h3 class="box-title">
                        <span>Acciones <br>USA </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid3.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Cedears </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid4.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Caución </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid5.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Opciones </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid6.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Futuros </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid7.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Bonos </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid8.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Licitaciones </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid9.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Letras </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid10.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Obligaciones <br>Negociables </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid11.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Fondos <br>Comunes </span>
                    </h3>
                </div>
                <div class="item">
                    <div class="img"><img loading="lazy" src="@/assets/images/gid12.svg" alt=""></div>
                    <h3 class="box-title">
                        <span> Dólar </span>
                    </h3>
                </div>
            </div>
            <div class="list2">
                <ul class="unstyle sasi-icon-list-items ">
                    <li class="sasi-icon-list-item ">
                        <span class="sasi-icon-list-icon">
                            <img loading="lazy" src="@/assets/images/hdui.svg" alt=""> </span>
                        <span class="sasi-icon-list-text ">Generá ingresos fijos y cobertura en pesos y en
                            dólares.</span>
                    </li>
                    <li class="sasi-icon-list-item ">
                        <span class="sasi-icon-list-icon">
                            <img loading="lazy" src="@/assets/images/hdui.svg" alt="">
                        </span>
                        <span class="sasi-icon-list-text ">
                            Accedé a nuestro supermercado de fondos multipropósito.
                        </span>
                    </li>
                    <li class="sasi-icon-list-item ">
                        <span class="sasi-icon-list-icon">
                            <img loading="lazy" src="@/assets/images/hdui.svg" alt=""></span>
                        <span class="sasi-icon-list-text ">Invertí en compañías locales y globales.</span>
                    </li>
                    <li class="sasi-icon-list-item ">
                        <span class="sasi-icon-list-icon">
                            <img loading="lazy" src="@/assets/images/hdui.svg" alt=""></span>
                        <span class="sasi-icon-list-text ">Comprá y vendé dólares financieros en un clic.</span>
                    </li>
                </ul>
            </div>
            <div class="btn-box">
                <router-link class="btn" to="/BullMarketBrokers">Abrí tu cuenta</router-link>
            </div>
        </div>
        <div class="bankuai-box bankuai1">
            <div class="sasi-heading">
                <span class="sasi-heading__sub">Herramientas de inversión</span>
                <h1 class="sasi-heading__title">Invertís a tu modo</h1>
                <h4 class="msg">Nuestro asesoramiento y tecnología a favor de tus ahorros.</h4>
            </div>
        </div>
        <div class="bk-list">
            <div class="bankuai-box bankuai2">
                <h3 class="sasi-heading__title">Resultados de <br>inversión</h3>
                <p>Análisis de cuenta automatizado<br>en tiempo real, en pesos y dólares</p>
                <img loading="lazy" src="@/assets/images/pill1-1.jpg" alt="">
            </div>
            <div class="bankuai-box bankuai2">
                <h3 class="sasi-heading__title">Oportunidades <br>de inversión</h3>
                <p>Alternativas de inversión<br>enfocadas en tu perfil</p>
                <img loading="lazy" src="@/assets/images/pill-anim.gif" alt="">
            </div>
            <div class="bankuai-box bankuai2 paddinf-bottom">
                <h3 class="sasi-heading__title">Data de <br>mercado</h3>
                <p>Conocé al máximo <br>tus inversiones.</p>
                <img loading="lazy" src="@/assets/images/pill3-1.jpg" alt="">
            </div>
        </div>
        <div class="box3">
            <div class="sasi-heading">
                <span class="sasi-heading__sub">Cursos y eventos</span>
                <h1 class="sasi-heading__title">Aprendé a invertir con Bull Educa</h1>
                <h4 class="msg">Disfrutá de aprender a manejar tu plata con nuestros especialistas.</h4>
                <router-link class="btn" to="/BullMarketBrokers">Abrí tu cuenta</router-link>
            </div>
        </div>
    </div>
    <div class="page-box2">
        <div class="sasi-heading">
            <span class="sasi-heading__sub">Cómo empezar</span>
            <h1 class="sasi-heading__title">Hacemos que<br> invertir sea <span class="blue">simple</span></h1>
            <h4 class="msg">Invertir no es complicado, es necesario.<br>Empezá a construir tu patrimonio con nuestro
                asesoramiento.</h4>
        </div>
        <div class="bamkuai-list">
            <div class="bbankuai">
                <p><span class="number">1</span></p>
                <h5 class="h5">Completás<br>tus datos</h5>
                <p class="msg">Es 100% online <br>En menos de 5 minutos</p>
            </div>
            <div class="bbankuai">
                <p><span class="number">2</span></p>
                <h5 class="h5">Validás tu<br>identidad</h5>
                <p class="msg">DNI<br>Frente y dorso</p>
            </div>
            <div class="bbankuai">
                <p><span class="number">3</span></p>
                <h5 class="h5">Transferís<br>dinero</h5>
                <p class="msg">Acreditaciones<br>en minutos</p>
            </div>
            <div class="bbankuai" style="background-color: #1e27f3;">
                <p><span class="number" style="background-color: #fff;color: #1e27f3;">4</span></p>
                <h5 class="h5"><span style="color: #ffffff;">Empezás<br>a invertir</span></h5>
                <p class="msg"><span style="color: #ffffff;">Acompañamiento y<br>asesoramiento</span></p>
            </div>
        </div>
        <div class="btn-box ptom">
            <router-link class="btn" to="/BullMarketBrokers">Abrí tu cuenta</router-link>
        </div>
    </div>
    <div class="page-box2" style="background-color: #ffffff;">
        <div class="sasi-heading">
            <span class="sasi-heading__sub">Nuestros clientes</span>
            <h1 class="sasi-heading__title">25 años brindando<br> confianza y resultados</h1>
            <h4 class="msg">Acompañamos y aseguramos cada paso de tus inversiones</h4>
        </div>
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" ref="myswipe">
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Gracias por pensar en los inversores!</div>
                    <div class="testi-quote">Hay que reconocer que la estabilidad de la plataforma web mejoró muchísimo.
                        En días de MUCHA actividad, sigue firme y se opera con normalidad.</div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Nicolas Gonzalez</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Muy rápidos los ingresos y egresos</div>
                    <div class="testi-quote">
                        Años que tengo cuenta en Bull y siempre un 10 la plataforma y el equipo. Muy pocas veces habré
                        tenido una demora en acreditaciones, pero siempre son muy rápidos los ingresos y egresos.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Dogblood</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle"> Me respondieron por chat en menos de 2 min.</div>
                    <div class="testi-quote">
                        El equipo de atención al cliente es lo mejor. Me respondieron por chat en menos de 2 min. y
                        resolvieron una consulta sobre dólar MEP sin dar vueltas.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Alejandro Mantelli</a>&nbsp;
                        </div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Muy cómodo para armar estrategias.</div>
                    <div class="testi-quote">
                        Me encanta poder operar todo en un mismo lugar. Acciones locales, CEDEARs, bonos y futuros sin
                        cambiar de pantalla.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Eduardo</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Excelente la atención y asesoramiento</div>
                    <div class="testi-quote">
                        Desde que abrí la cuenta siempre he sido atendida telefónicamente y también por mensajería
                        interna. Excelente la atención y asesoramiento de Franco, quien siempre tiene una excelente
                        predisposición y profesionalismo para explicarme y asesorarme.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Silvana Choren</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Transparentes y rápidos, da confianza.</div>
                    <div class="testi-quote">
                        Retire fondos en 7 min., vendí bonos AL30 y el egreso a mi cuenta bancaria fue automático.
                        Transparentes y rápidos, da confianza.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Jony Molina</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Gran plus para traders.</div>
                    <div class="testi-quote">
                        Todo en un solo lugar, portafolio con acciones ARgentina, CEDEARs de Nvidia y futuros ROFEX...
                        ¡sin cambiar de pantalla! Gran plus para traders.
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">InfoBaeAr</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="item">
                    <div class="testi-stitle">Horas de cursos gratuitos. La recomiendo!</div>
                    <div class="testi-quote">
                        El alta fue muy rápido. Lo hice desde la PC y después usé el celular para validar identidad. En
                        muy poco tiempo ya estaba operando. Además tiene horas de cursos gratuitos. La recomiendo!
                    </div>
                    <div class="tinfo">
                        <div class="tname"><a href="javascript:void(0)" target="_blank">Hugo Álvarez</a>&nbsp;</div>
                    </div>
                    <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star" void-color="#eee" />
                </div>
            </van-swipe-item>
            <template #indicator="{ active, total }">
                <div class="custom-indicator" :key="active" v-if="total">
                    <div class="item" :class="{ active: active == index }" @click="onChange(v)"
                        v-for="(v, index) in total || 0" :key="index">
                        <div class="dian"></div>
                    </div>
                </div>
            </template>
        </van-swipe>
        <van-swipe class="my-swipe2" :autoplay="3000" indicator-color="white" ref="myswipe">
            <van-swipe-item>
                <div class="swipe-list">
                    <div class="item">
                        <div class="testi-stitle">Gracias por pensar en los inversores!</div>
                        <div class="testi-quote">Hay que reconocer que la estabilidad de la plataforma web mejoró
                            muchísimo.
                            En días de MUCHA actividad, sigue firme y se opera con normalidad.</div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Nicolas Gonzalez</a>&nbsp;
                            </div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle">Muy rápidos los ingresos y egresos</div>
                        <div class="testi-quote">
                            Años que tengo cuenta en Bull y siempre un 10 la plataforma y el equipo. Muy pocas veces
                            habré
                            tenido una demora en acreditaciones, pero siempre son muy rápidos los ingresos y egresos.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Dogblood</a>&nbsp;</div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle"> Me respondieron por chat en menos de 2 min.</div>
                        <div class="testi-quote">
                            El equipo de atención al cliente es lo mejor. Me respondieron por chat en menos de 2 min. y
                            resolvieron una consulta sobre dólar MEP sin dar vueltas.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Alejandro Mantelli</a>&nbsp;
                            </div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle">Muy cómodo para armar estrategias.</div>
                        <div class="testi-quote">
                            Me encanta poder operar todo en un mismo lugar. Acciones locales, CEDEARs, bonos y futuros
                            sin
                            cambiar de pantalla.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Eduardo</a>&nbsp;</div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                </div>
            </van-swipe-item>
            <van-swipe-item>
                <div class="swipe-list">
                    <div class="item">
                        <div class="testi-stitle">Excelente la atención y asesoramiento</div>
                        <div class="testi-quote">
                            Desde que abrí la cuenta siempre he sido atendida telefónicamente y también por mensajería
                            interna. Excelente la atención y asesoramiento de Franco, quien siempre tiene una excelente
                            predisposición y profesionalismo para explicarme y asesorarme.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Silvana Choren</a>&nbsp;
                            </div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle">Transparentes y rápidos, da confianza.</div>
                        <div class="testi-quote">
                            Retire fondos en 7 min., vendí bonos AL30 y el egreso a mi cuenta bancaria fue automático.
                            Transparentes y rápidos, da confianza.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Jony Molina</a>&nbsp;</div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle">Gran plus para traders.</div>
                        <div class="testi-quote">
                            Todo en un solo lugar, portafolio con acciones ARgentina, CEDEARs de Nvidia y futuros
                            ROFEX...
                            ¡sin cambiar de pantalla! Gran plus para traders.
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">InfoBaeAr</a>&nbsp;</div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                    <div class="item">
                        <div class="testi-stitle">Horas de cursos gratuitos. La recomiendo!</div>
                        <div class="testi-quote">
                            El alta fue muy rápido. Lo hice desde la PC y después usé el celular para validar identidad.
                            En
                            muy poco tiempo ya estaba operando. Además tiene horas de cursos gratuitos. La recomiendo!
                        </div>
                        <div class="tinfo">
                            <div class="tname"><a href="javascript:void(0)" target="_blank">Hugo Álvarez</a>&nbsp;</div>
                        </div>
                        <van-rate v-model="value" :size="20" color="#ff9d2c" readonly void-icon="star"
                            void-color="#eee" />
                    </div>
                </div>
            </van-swipe-item>
            <template #indicator="{ active, total }">
                <div class="custom-indicator" :key="active" v-if="total">
                    <div class="item" :class="{ active: active == index }" @click="onChange(v)"
                        v-for="(v, index) in total || 0" :key="index">
                        <div class="dian"></div>
                    </div>
                </div>
            </template>
        </van-swipe>
        <div class="help-box">
            <div class="sasi-heading">
                <span class="sasi-heading__sub">Preguntas frecuentes</span>
                <h1 class="sasi-heading__title">Te ayudamos siempre</h1>
                <h4 class="msg">Consultá las preguntas frecuentes o ingresá a nuestro centro de ayuda para más
                    información
                </h4>
                <div class="btn" @click="openService">Contáctenos</div>
            </div>
            <div class="help-list" :key="activeIndex">
                <div class="item" v-for="(item, index) in list" :key="item.q"
                    :class="{ active: activeIndex === index }">
                    <div class="question" @click="toggle(index)">
                        <span>{{ item.q }}</span>
                        <i class="arrow"></i>
                    </div>
                    <div class="answer">
                        <p v-html="item.a"></p>
                    </div>
                </div>
            </div>
        </div>
        <div class="h-bankuai">
            <div class="con">
                <div class="sasi-heading">
                    <span class="sasi-heading__sub">Activá tu cuenta</span>
                    <h1 class="sasi-heading__title">Empezar a invertir, ya no tiene excusa.</h1>
                </div>
                <div class="list">
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Apertura sin costo </h3>
                    </div>
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Asesoramiento profesional</h3>
                    </div>
                    <div class="item">
                        <div class="img"><img loading="lazy" src="@/assets/images/bdui.svg" alt=""></div>
                        <h3 class="ps"> Herramientas de inversión </h3>
                    </div>
                </div>
                <div class="btn-box">
                    <router-link class="btn" to="/BullMarketBrokers">Abrí tu cuenta</router-link>
                </div>
                <img loading="lazy" class="img-db" src="@/assets/images/abri-cuenta-mano-1-1.jpg" alt="">
            </div>
        </div>
    </div>
    <div class="page-box3 blueBorder">
        <div class="page-box3-con">
            <div class="item">
                <div class="logo">
                    <img loading="lazy" src="@/assets/images/logo.png" alt="">
                </div>
                <p class="ps">Impulsamos tus inversiones</p>
            </div>
            <div class="item">
                <div class="listicon">
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons1.svg" alt="">
                    </a>
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons2.svg" alt="">
                    </a>
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons3.svg" alt="">
                    </a>
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons4.svg" alt="">
                    </a>
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons5.svg" alt="">
                    </a>
                    <a href="javascript:void(0)" target="_blank" class="item">
                        <img loading="lazy" src="@/assets/images/icons6.svg" alt="">
                    </a>
                </div>
                <div class="appbox">
                    <a href="https://play.google.com/store/apps/details?id=com.rdberntn.tnvmhyryn" target="_blank"
                        class="itemapp">
                        <img loading="lazy"
                            src="@/assets/images/logos-para-web-legales_Disponible-en-Google-Play-Negro.png" alt="">
                    </a>
                    <a href="https://apps.apple.com/app/id6756229981" target="_blank" class="itemapp">
                        <img loading="lazy"
                            src="@/assets/images/logos-para-web-legales_Disponible-en-App-Store-Blanco-300x89-1.png"
                            alt="">
                    </a>
                </div>
            </div>
            <div class="item">
                <p class="msgtxt">Suite 2600, 535 Mission Street, San Francisco, California, Estados Unidos</p>
                <!-- <p class="alist">
                    <a href="javascript:void(0)">Términos y Condiciones</a>
                    <a href="javascript:void(0)">Privacidad</a>
                    <a href="javascript:void(0)">Cumplimiento</a>
                    <a href="javascript:void(0)">Protección al inversor</a>
                </p> -->
                <!-- <h5 class="bull">Servicios Bull</h5>
                <p class="Bulls">
                    <a href="javascript:void(0)">Bull Pay</a><br />
                    <a href="javascript:void(0)">Bull Educa</a><br />
                    <a href="javascript:void(0)">Bull Seguros</a><br />
                    <a href="javascript:void(0)">Bull Internacional</a><br />
                    <a href="javascript:void(0)">Bull Institucional</a><br />
                    <a href="javascript:void(0)">Bull Fondos</a>
                </p> -->
            </div>
        </div>
        <div class="heibox">
            <a href="http://www.mav-sa.com.ar/" target="_blank">
                <img loading="lazy" src="@/assets/images/01-mv.png" alt="">
            </a>
            <a href="https://www.byma.com.ar/" target="_blank">
                <img loading="lazy" src="@/assets/images/01-byma.png" alt="">
            </a>
            <a href="https://www.mae.com.ar/" target="_blank">
                <img loading="lazy" src="@/assets/images/01-a3.png" alt="">
            </a>
            <a href="https://www.nasdaq.com/" target="_blank">
                <img loading="lazy" src="@/assets/images/01-nasdaq.png" alt="">
            </a>
            <a href="https://www.nyse.com/index" target="_blank">
                <img loading="lazy" src="@/assets/images/01-nyse.png" alt="">
            </a>
        </div>
        <div class="imgs-box">
            <a href="https://www.bcra.gob.ar/BCRAyVos/Usuarios_Financieros.asp" target="_blank" class="imgaunll">
                <img loading="lazy" src="@/assets/images/footer-ufi-1.jpg" alt="">
            </a>
            <a href="http://www.cnv.gov.ar/" target="_blank">
                <img loading="lazy" src="@/assets/images/footer-cnv-1-1.jpg" alt="">
            </a>
            <a href="https://cajadevalores.com.ar/" target="_blank">
                <img loading="lazy" src="@/assets/images/footer-valo-1-1.jpg" alt="">
            </a>
            <a href="https://www.argentina.gob.ar/superintendencia-de-seguros" target="_blank">
                <img loading="lazy" src="@/assets/images/footer-ssn-1-1.jpg" alt="">
            </a>
            <a href="https://www.finra.org/" target="_blank">
                <img loading="lazy" src="@/assets/images/footer-finra-2.jpg" alt="">
            </a>
            <a href="https://www.sec.gov/" target="_blank">
                <img loading="lazy" src="@/assets/images/footer-us-1-1.jpg" alt="">
            </a>
        </div>
        <p class="pnav">
            <a href="javascript:void(0)">Público inversor | </a>
            <a href="javascript:void(0)" target="_blank" rel="noopener">Caja de valores</a> |
            <a href="javascript:void(0)" target="_blank" rel="noopener">Personal idóneo</a> |
            <a href="javascript:void(0)" target="_blank" rel="noopener">Defensa al consumidor</a>&nbsp;
        </p>
    </div>
    <!-- <div class="text-box">
        <p><span style="white-space-collapse: preserve;"><span style="text-decoration: underline;">MatrixQuant Brokers
                    S.A.
                    | CUIT: 30-70703253-3</span><br>Bouchard 680, Piso 8° (C1106ABJ) CABA – Argentina | Agente de
                Liquidación y Comensación Propio N° 247 ante C.N.V. y Agente de Colocación y Distribución Integral de
                Fondos
                Comunes Nº28 ante la C.N.V</span></p>
        <p class="ckgd" @click="gdActive = !gdActive">
            <van-icon name="arrow-down" />
            <span> Ver más</span>
        </p>
        <div class="gdlist" :class="{ active: gdActive }">
            <p><span style="text-decoration-line: underline; white-space-collapse: preserve;">MatrixQuant Asset
                    Management
                    S.A. | CUIT 33-71559320-9</span></p>
            <p><span style="white-space-collapse: preserve;">Bouchard 680, Piso 9° (C1106ABJ) CABA – Argentina | Agente
                    de
                    Administración de Productos de Inversión Colectiva registrado bajo el N° 57 ante CNV.</span></p>
            <p><span style="white-space-collapse: preserve;"><span style="text-decoration: underline;">Stockholder S.A.
                        |
                        CUIT: 30-69607859-5</span><br>Roque Perez 3108 (C1430FBN) CABA – Argentina | Proveedor de
                    Servicios
                    de Pago registrado en BCRA bajo el N° 33.546 y Agente Institorio registrado ante la SSN bajo el N°
                    366</span></p>
            <p><span style="white-space-collapse: preserve;"><span style="text-decoration: underline;">BM Capital S.A. |
                        CUIT: 30-70703253-3</span><br></span><span style="white-space-collapse: preserve;">Bouchard 680,
                </span><span style="white-space-collapse: preserve;">Piso 9° (C1106ABJ) CABA – Argentina | Agente de
                    Liquidación y Comensación Propio N° 2609 ante C.N.V.</span></p>
        </div>
    </div> -->
    <div class="dibuw">
        <p style="text-align: center;"><span style="color: #ffffff;">© MatrixQuant | 2025 – Todos los derechos
                reservados.</span></p>
    </div>
</template>
<style scoped lang="scss">
.btn-box {
    display: flex;
    justify-content: center;

    .btn {
        background-color: #1e27f3;
        color: #fff;
        font-size: 16px;
        padding: 14.5px 25px;
        border-radius: 500px;
        font-weight: 600;
        cursor: pointer;
    }
}

.btn {
    transition: all 0.3s;

    &:hover {
        background-color: #0e0e0e !important;
        color: #fff !important;
    }
}

.page-box {
    width: 100%;
    max-width: 600px;
    padding: 0 15px 70px;
    margin: 0 auto;

    .box1 {
        padding: 50px 15px;
        display: flex;
        flex-direction: column;
        gap: 30px;

        .lf {
            display: flex;
            flex-direction: column;
            gap: 30px;

            .ps {
                font-size: 12px;
                color: #808080;
                font-weight: 400;
                text-align: center;
            }

            .sasi-heading__title {
                font-size: 32px;
                color: #000011;
                text-align: center;
                font-weight: 600;

                .blue {
                    color: #1f27f3;
                }
            }

            .msg {
                font-size: 18px;
                color: gray;
                font-weight: 400;
                text-align: center;
            }

            .list {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .line {
                    display: flex;
                    align-items: center;

                    .img {
                        width: 32px;
                        height: 32px;
                        background-color: #000011;
                        border-radius: 50%;
                        margin-right: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        img {
                            width: 16px;
                        }
                    }

                    span {
                        font-size: 16px;
                        color: #000011;
                    }
                }
            }
        }



        .cuenta-de {
            width: 100%;
            margin-top: 10px;

            img {
                width: 100%;
            }
        }

    }

    .box2 {
        padding: 70px 0 0;

        .content {
            background-image: url('@/assets/images/somos.jpg');
            background-position: 50%;
            background-size: cover;
            height: 100%;
            width: 100%;
            padding: 30px;
            border-radius: 20px;

            .sasi-heading {
                text-align: center;
                margin-bottom: 20px;

                .sasi-heading__sub {
                    display: inline-block;
                    color: #FFF;
                    background-color: #333;
                    border-color: #000011;
                    font-size: 14px;
                    padding: 10px 20px;
                    margin-bottom: 10px;
                    font-weight: 500;
                    line-height: 1;
                    border-radius: 999px;
                }

                .sasi-heading__title {
                    font-size: 36px;
                    font-weight: 600;
                    color: #fff;
                }
            }

            .msg {
                font-size: 18px;
                color: #fff;
                text-align: center;
                padding: 0 30px;
                font-weight: 400;
                margin-bottom: 30px;
            }

            .list {
                padding: 15px;
                display: flex;
                flex-direction: column;
                gap: 20px;

                .item {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    align-items: center;

                    .img {
                        background-color: #333;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .ps {
                        text-align: center;
                        color: #fff;
                        font-size: 16px;
                        margin-bottom: 20px;
                        font-weight: 500;
                    }
                }
            }
        }
    }

    .con-inner {
        padding: 70px 15px 0;

        &.paddinf-bottom {
            padding-bottom: 70px;
        }

        .title {
            color: #1a1a1c;
            font-size: 28px;
            margin-bottom: 40px;
            text-align: center;
            font-weight: 500;
        }

        .list {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            a {
                img {
                    width: 180px;
                    filter: grayscale(1);
                    height: auto;
                }
            }
        }

        .sasi-heading {
            text-align: center;
            margin-bottom: 20px;

            .sasi-heading__sub {
                color: #1A1A1C;
                background-color: #FEF7D6;
                border-color: #FFF;
                font-size: 14px;
                padding: 10px 20px;
                font-weight: 500;
                border-radius: 999px;
                display: inline-block;
                margin-bottom: 10px;
            }

            .sasi-heading__title {
                color: #000011;
                font-size: 36px;
                font-weight: 600;
                line-height: 1.4;
            }

            .blue {
                color: #1f27f3;
            }
        }

        .msg {
            color: gray;
            text-align: center;
            font-size: 18px;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 20px;
        }

        .grid {
            margin-bottom: 20px;
            display: grid;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 20px;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 15px;

                .img {
                    width: 116px;
                    height: 116px;
                    background: #edf0ff;
                    border-radius: 15px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 96px;
                    }
                }

                .box-title {
                    font-size: 16px;
                    color: #808080;
                    text-align: center;
                    font-weight: 500;
                    margin-bottom: 20px;
                }
            }
        }

        .list2 {
            padding: 0 10px;
            margin-bottom: 30px;

            .sasi-icon-list-item {
                display: flex;
                align-items: center;
                line-height: 36px;
                word-break: normal;
                justify-content: flex-start;
                margin-bottom: 15px;

                .sasi-icon-list-icon {
                    display: inline-block;
                    font-size: 16px;
                    text-align: center;
                    flex-shrink: 0;
                    margin-right: 10px;
                    line-height: 1;
                    overflow: hidden;
                    transition: all 0.3s linear;
                    margin-right: 15px;

                    img {
                        width: 16px;
                    }
                }

                .sasi-icon-list-text {
                    align-self: center;
                    font-size: 16px;
                    color: #696969;
                }
            }
        }
    }

    .bankuai-box {
        background-color: #F6F6F6;
        border-radius: 20px;
        border: 1px solid #EDF0FF;
        margin-bottom: 30px;
        padding: 30px;
    }

    .bankuai1 {
        .sasi-heading {
            text-align: center;

            .sasi-heading__sub {
                color: #1A1A1C;
                background-color: #FEF7D6;
                border-color: #FFF;
                font-size: 14px;
                padding: 10px 20px;
                border: 1px solid #fff;
                border-radius: 999px;
                margin-bottom: 10px;
                font-weight: 500;
                display: inline-block;
            }

            .sasi-heading__title {
                font-size: 36px;
                color: #000011;
                font-weight: 600;
                margin-bottom: 20px;
            }

            .msg {
                color: gray;
                font-size: 18px;
                font-weight: 400;
            }
        }
    }

    .bankuai2 {
        display: flex;
        flex-direction: column;
        gap: 20px;

        .sasi-heading__title {
            font-weight: 500;
            font-size: 28px;
            color: #000011;
            text-align: center;
        }

        p {
            color: #808080;
            font-size: 14px;
        }

        img {
            border-radius: 20px;
            width: 100%;
        }
    }

    .box3 {
        margin-top: 70px;
        padding: 30px;
        border-radius: 20px;
        background-position: 50%;
        background-size: cover;
        background-image: url("@/assets/images/bull-educa-imagen-claro-1-1.png");

        .sasi-heading {
            text-align: center;

            .sasi-heading__sub {
                color: #1A1A1C;
                background-color: #FEF7D6;
                border-color: #FFF;
                font-size: 14px;
                padding: 10px 20px;
                border: 1px solid #fff;
                border-radius: 999px;
                margin-bottom: 10px;
                font-weight: 500;
                display: inline-block;
            }

            .sasi-heading__title {
                font-size: 36px;
                color: #000011;
                font-weight: 600;
                margin-bottom: 20px;
            }

            .msg {
                color: gray;
                font-size: 18px;
                font-weight: 400;
            }
        }

        .btn {
            background-color: #FFFFFF;
            display: inline-block;
            border: 1px solid #1e27f3;
            border-radius: 300px;
            color: #1e27f3;
            padding: 15px 25px;
            font-size: 16px;
            margin-top: 20px;
            font-weight: 600;
            cursor: pointer;
        }
    }
}

.blueBorder {
    border-top: 4px solid #1e27f3;
}

.page-box2 {
    width: 100%;
    max-width: 600px;
    background-color: #f6f6f6;
    padding: 70px 15px;

    .sasi-heading {
        text-align: center;
        margin-bottom: 50px;

        .sasi-heading__sub {
            color: #1A1A1C;
            background-color: #FEF7D6;
            border-color: #FFF;
            font-size: 14px;
            padding: 10px 20px;
            border: 1px solid #fff;
            border-radius: 999px;
            margin-bottom: 10px;
            font-weight: 500;
            display: inline-block;
        }

        .sasi-heading__title {
            font-size: 36px;
            color: #000011;
            font-weight: 600;
            margin-bottom: 20px;
        }

        .msg {
            color: gray;
            font-size: 18px;
            font-weight: 400;
        }

        .blue {
            color: #1f27f3;
        }
    }

    .bbankuai {
        padding: 30px 20px;
        background-color: #fff;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        align-items: center;
        margin-bottom: 20px;

        .number {
            display: inline-block;
            background-color: #000011;
            width: 36px;
            height: 36px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: 18px;
        }

        .h5 {
            font-size: 24px;
            color: #1a1a1c;
            text-align: center;
            font-weight: 700;
        }

        .msg {
            color: #808080;
            font-size: 14px;
            text-align: center;
            font-weight: 400;
        }
    }

    .btn-box {
        display: flex;
        justify-content: center;

        &.ptom {
            padding-top: 30px;
        }

        .btn {
            background-color: #1e27f3;
            color: #fff;
            font-size: 16px;
            padding: 14.5px 25px;
            border-radius: 500px;
            font-weight: 600;
            cursor: pointer;
        }
    }



    .my-swipe {
        display: block;
        margin-bottom: 70px;

        .van-swipe-item {
            border: 1px solid #eeeeee;
            border-radius: 15px;
            padding: 27px 30px;

            .item {
                .testi-stitle {
                    margin-bottom: 20px;
                    color: #0e0e0e;
                    font-size: 16px;
                    font-weight: 600;
                }

                .testi-quote {
                    color: #696969;
                    font-size: 16px;
                    margin-bottom: 30px;
                }

                .tname {
                    margin-bottom: 5px;

                    a {
                        color: #1f27f3;
                        font-size: 16px;
                        font-weight: 600;
                    }
                }
            }
        }

        .custom-indicator {
            display: flex;
            justify-content: center;
            gap: 12px;
            margin-top: 25px;

            .item {
                width: 27px;
                height: 27px;
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 50%;

                .dian {
                    width: 9px;
                    height: 9px;
                    background-color: #696969;
                    border-radius: 50%;
                }

                &.active {
                    border: 1px solid #0e0e0e !important;

                    .dian {
                        background-color: #0e0e0e !important;
                    }
                }
            }
        }
    }

    .my-swipe2 {
        display: none;
    }

    .help-box {
        .btn {
            background-color: #FFFFFF;
            display: inline-block;
            border: 1px solid #1e27f3;
            border-radius: 300px;
            color: #1e27f3;
            padding: 15px 25px;
            font-size: 16px;
            margin-top: 20px;
            font-weight: 600;
            cursor: pointer;
        }

        .help-list {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #eee;
            overflow: hidden;

            .item {
                border-bottom: 1px solid #f0f0f0;

                &:last-child {
                    border-bottom: none;
                }

                .question {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 18px 16px;
                    font-size: 15px;
                    font-weight: 500;
                    color: #000;
                    cursor: pointer;

                    .arrow {
                        width: 28px;
                        height: 28px;
                        border-radius: 50%;
                        background: #f2f2f2;
                        position: relative;
                        transition: transform 0.3s;

                        &::before {
                            content: '';
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 8px;
                            height: 8px;
                            border-right: 2px solid #000;
                            border-bottom: 2px solid #000;
                            transform: translate(-50%, -50%) rotate(45deg);
                        }
                    }
                }

                .answer {
                    max-height: 0;
                    overflow: hidden;
                    transition: max-height 0.3s ease;
                    padding: 0 16px;

                    p {
                        margin: 0;
                        padding: 0 0 16px;
                        font-size: 14px;
                        color: #777;
                        line-height: 1.6;
                    }
                }

                &.active {
                    .arrow {
                        transform: rotate(180deg);
                        background: #2f54eb;

                        &::before {
                            border-color: #fff;
                        }
                    }

                    .answer {
                        max-height: 200px;
                        /* 足够用即可 */
                    }
                }
            }
        }
    }



    .h-bankuai {
        background-color: #000011;
        margin-top: 30px;
        border-radius: 20px;

        .con {
            padding: 30px;

            .sasi-heading {
                text-align: center;
                margin-bottom: 50px;

                .sasi-heading__sub {
                    color: #fff;
                    background-color: #333333;
                    font-size: 14px;
                    padding: 10px 20px;
                    border: 1px solid #000011;
                    border-radius: 999px;
                    margin-bottom: 10px;
                    font-weight: 500;
                    display: inline-block;
                }

                .sasi-heading__title {
                    font-size: 28px;
                    color: #fff;
                    font-weight: 500;
                    margin-bottom: 20px;
                }
            }

            .list {
                padding: 15px;
                display: flex;
                flex-direction: column;
                gap: 20px;

                .item {
                    display: flex;
                    flex-direction: column;
                    gap: 15px;
                    align-items: center;

                    .img {
                        background-color: #333;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .ps {
                        text-align: center;
                        color: #fff;
                        font-size: 16px;
                        margin-bottom: 20px;
                        font-weight: 500;
                    }
                }
            }

            .btn-box {
                display: flex;
                justify-content: center;

                .btn {
                    background-color: #1e27f3;
                    color: #fff;
                    font-size: 16px;
                    padding: 14.5px 25px;
                    border-radius: 500px;
                    font-weight: 600;
                    cursor: pointer;
                }
            }

            .img-db {
                width: calc(100% + 30px);
                margin-top: 50px;
            }
        }
    }
}

.page-box3 {
    width: 100%;
    max-width: 600px;
    background-color: #fff;
    padding: 50px 15px;
    margin: auto;

    .logo {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;

        img {
            width: 180px;
        }
    }

    .ps {
        color: #1a1a1c;
        font-size: 21px;
        text-align: center;
        margin-bottom: 20px;
    }

    .listicon {
        display: flex;
        gap: 10px;
        justify-content: center;
        margin-top: 40px;
        margin-bottom: 30px;

        .item {
            border: 1px solid #1e27f3;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 17px;
                height: 17px;
            }
        }
    }

    .itemapp {
        display: flex;
        justify-content: center;
        margin-bottom: 15px;

        img {
            width: 200px;
        }
    }

    .msgtxt {
        font-size: 14px;
        color: #808080;
        text-align: center;
        margin-top: 40px;
        margin-bottom: 30px;
    }

    .alist {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
        color: #1f27f3;
    }

    .bull {
        margin-top: 40px;
        text-align: center;
        color: #1a1a1c;
        font-size: 21px;
        margin-bottom: 20px;
        font-weight: 400;
    }

    .Bulls {
        text-align: center;
        margin-bottom: 10px;

        a {
            font-size: 14px;
            color: #808080;
        }
    }

    .heibox {
        background-color: #000011;
        padding: 50px 70px;
        border-radius: 20px;
        margin-top: 70px;
        display: flex;
        flex-direction: column;
        gap: 15px;

        img {
            width: 220px;
        }
    }

    .imgaunll {
        display: inline-block;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 70px;
        margin-bottom: 40px;

        img {
            width: 180px;
            filter: grayscale(1);
        }
    }

    .imgs-box {
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 180px;
            filter: grayscale(1);
        }
    }

    .pnav {
        color: #808080;
        text-align: center;

        a {
            color: #808080;
            font-size: 14px;
        }
    }

}

.text-box {
    background-color: #f6f6f6;
    padding: 30px 15px;
    text-align: center;
    font-size: 14px;
    color: #808080;
    line-height: 2;

    .ckgd {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #1f2124;
        margin-top: 30px;

        i {
            font-size: 26px;
        }
    }

    .gdlist {
        margin-top: 20px;
        max-height: 0;
        overflow: hidden;
        transition: all 0.3s;

        &.active {
            max-height: 500px;
        }

        p {
            margin-bottom: 15px;
        }
    }
}

.dibuw {
    background-color: #000011;
    text-align: center;
    padding: 15px;
    font-size: 15px;
    color: #fff;
}

@media screen and (min-width: 601px) {
    .btn-box {
        display: flex;
        justify-content: flex-start;

        .btn {
            background-color: #1e27f3;
            color: #fff;
            font-size: 16px;
            padding: 16px 25px;
            border-radius: 500px;
            font-weight: 600;
            cursor: pointer;
        }
    }

    .page-box {
        width: 1290px;
        max-width: 1290px;
        padding: 50px 15px 70px;


        .box1 {
            padding: 50px 15px;
            display: flex;
            flex-direction: row;
            gap: 30px;

            .lf {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 30px;
                padding-right: 40px;

                .ps {
                    font-size: 12px;
                    color: #808080;
                    font-weight: 400;
                    text-align: left;
                }

                .sasi-heading__title {
                    font-size: 64px;
                    color: #000011;
                    text-align: left;
                    font-weight: 600;

                    .blue {
                        color: #1f27f3;
                    }
                }

                .msg {
                    font-size: 24px;
                    color: gray;
                    font-weight: 400;
                    text-align: left;
                }

                .list {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    gap: 10px;

                    .line {
                        flex: calc(50% - 10px);
                        display: flex;
                        align-items: center;

                        .img {
                            width: 32px;
                            height: 32px;
                            background-color: #000011;
                            border-radius: 50%;
                            margin-right: 10px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            img {
                                width: 16px;
                            }
                        }

                        span {
                            font-size: 16px;
                            color: #000011;
                        }
                    }
                }
            }

            .cuenta-de {
                width: 570px;
                margin-top: 0px;
                flex-shrink: 0;

                img {
                    width: 100%;
                }
            }

        }

        .box2 {
            padding: 70px 0 0;

            .content {
                background-image: url('@/assets/images/somos.jpg');
                background-position: 50%;
                background-size: cover;
                height: 100%;
                width: 100%;
                padding: 50px 200px;
                border-radius: 20px;

                .sasi-heading {
                    text-align: center;
                    margin-bottom: 20px;

                    .sasi-heading__sub {
                        display: inline-block;
                        color: #FFF;
                        background-color: #333;
                        border-color: #000011;
                        font-size: 16px;
                        padding: 12px 28px;
                        margin-bottom: 10px;
                        font-weight: 500;
                        line-height: 1;
                        border-radius: 999px;
                    }

                    .sasi-heading__title {
                        font-size: 64px;
                    }
                }

                .msg {
                    font-size: 24px;
                }

                .list {
                    padding: 15px;
                    display: flex;
                    flex-direction: row;
                    gap: 20px;

                    .item {
                        display: flex;
                        flex-direction: column;
                        gap: 15px;
                        align-items: center;

                        .img {
                            background-color: #333;
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .ps {
                            text-align: center;
                            color: #fff;
                            font-size: 16px;
                            margin-bottom: 20px;
                            font-weight: 500;
                        }
                    }
                }
            }
        }

        .con-inner {
            padding: 70px 0px 0;

            &.paddinf-bottom {
                padding-bottom: 70px;
            }

            .title {
                font-size: 36px;
            }

            .list {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                margin-bottom: 70px;

                a {
                    flex: 25%;

                    img {
                        width: 180px;
                        filter: grayscale(1);
                        height: auto;
                    }
                }
            }

            .sasi-heading {

                .sasi-heading__sub {
                    font-size: 16px;
                    padding: 12px 28px;
                }

                .sasi-heading__title {
                    color: #000011;
                    font-size: 64px;
                    font-weight: 600;
                    line-height: 1.2;
                }

                .blue {
                    color: #1f27f3;
                }
            }

            .msg {
                width: 774px;
                font-size: 24px;
                margin: 0 auto 70px;
            }

            .grid {
                margin-bottom: 70px;
                grid-template-columns: repeat(6, minmax(0, 1fr));
            }

            .list2 {
                padding: 0 10px;
                margin-bottom: 50px;

                .sasi-icon-list-item {
                    justify-content: center;
                }
            }

            .btn-box {
                display: flex;
                justify-content: center;
            }
        }

        .bankuai-box {
            background-color: #F6F6F6;
            border-radius: 20px;
            border: 1px solid #EDF0FF;
            margin-bottom: 30px;
            padding: 30px;
        }

        .bankuai1 {
            .sasi-heading {
                text-align: left;

                .sasi-heading__sub {
                    font-size: 16px;
                    padding: 12px 28px;
                }

                .sasi-heading__title {
                    font-size: 64px;
                }

                .msg {
                    color: gray;
                    font-size: 24px;
                    font-weight: 400;
                }
            }
        }

        .bk-list {
            display: flex;
            gap: 20px;
        }

        .bankuai2 {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .sasi-heading__title {
                font-size: 36px;
                text-align: left;
            }

            p {
                color: #808080;
                font-size: 16px;
            }

            img {
                width: 100%;
            }
        }

        .box3 {
            .sasi-heading {
                text-align: left;
                width: 615px;

                .sasi-heading__sub {
                    font-size: 16px;
                    padding: 12px 28px;
                }

                .sasi-heading__title {
                    font-size: 64px;
                }

                .msg {
                    font-size: 24px;
                }
            }

            .btn {
                padding: 16px 25px;
                cursor: pointer;
            }
        }
    }

    .page-box2 {
        width: 100%;
        max-width: 100%;
        margin-top: 30px;
        background-color: #f6f6f6;
        padding: 70px 15px;

        .sasi-heading {
            text-align: center;
            margin-bottom: 50px;

            .sasi-heading__sub {
                font-size: 16px;
                padding: 12px 28px;
                margin-bottom: 20px;
            }

            .sasi-heading__title {
                font-size: 64px;
            }

            .msg {
                font-size: 24px;
            }

            .blue {
                color: #1f27f3;
            }
        }

        .bamkuai-list {
            max-width: 1290px;
            padding: 0 15px;
            margin: auto;
            display: flex;
            margin: 70px auto 30px;
            gap: 20px;

            .bbankuai {
                flex: 1;
                padding: 30px 20px;
                background-color: #fff;
                border-radius: 20px;
                display: flex;
                flex-direction: column;
                gap: 20px;
                align-items: center;
                margin-bottom: 20px;

                .msg {
                    font-size: 16px;
                }
            }
        }

        .btn-box {
            display: flex;
            justify-content: center;

            &.ptom {
                padding-top: 0px;
            }

            .btn {
                background-color: #1e27f3;
                color: #fff;
                font-size: 16px;
                padding: 14.5px 25px;
                border-radius: 500px;
                font-weight: 600;
                cursor: pointer;
            }
        }



        .my-swipe {
            display: none;
        }

        .my-swipe2 {
            display: block;
            padding-top: 30px;
            max-width: 1290px;
            margin: 0 auto 70px;

            .van-swipe-item {

                .swipe-list {
                    display: flex;
                    gap: 20px;
                }

                .item {
                    flex: 1;
                    border: 1px solid #eeeeee;
                    border-radius: 15px;
                    padding: 27px 30px;

                    .testi-stitle {
                        margin-bottom: 20px;
                        color: #0e0e0e;
                        font-size: 16px;
                        font-weight: 600;
                    }

                    .testi-quote {
                        color: #696969;
                        font-size: 16px;
                        margin-bottom: 30px;
                    }

                    .tname {
                        margin-bottom: 5px;

                        a {
                            color: #1f27f3;
                            font-size: 16px;
                            font-weight: 600;
                        }
                    }
                }
            }

            .custom-indicator {
                display: flex;
                justify-content: center;
                gap: 12px;
                margin-top: 40px;

                .item {
                    width: 27px;
                    height: 27px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;

                    .dian {
                        width: 9px;
                        height: 9px;
                        background-color: #696969;
                        border-radius: 50%;
                    }

                    &.active {
                        border: 1px solid #0e0e0e !important;

                        .dian {
                            background-color: #0e0e0e !important;
                        }
                    }
                }
            }
        }

        .help-box {
            max-width: 1290px;
            margin: 0 auto 120px;
            display: flex;
            gap: 50px;

            .sasi-heading {
                text-align: left;
                margin-bottom: 0px;

                .sasi-heading__sub {
                    font-size: 16px;
                    padding: 12px 28px;
                    margin-bottom: 20px;
                }

                .sasi-heading__title {
                    font-size: 64px;
                }

                .msg {
                    font-size: 24px;
                }

                .blue {
                    color: #1f27f3;
                }
            }

            .btn {
                background-color: #FFFFFF;
                display: inline-block;
                border: 1px solid #1e27f3;
                border-radius: 300px;
                color: #1e27f3;
                padding: 15px 25px;
                font-size: 16px;
                margin-top: 70px;
                font-weight: 600;
                cursor: pointer;
            }

            .help-list {
                background: #fff;
                border-radius: 16px;
                border: 1px solid #eee;
                overflow: hidden;

                .item {
                    border-bottom: 1px solid #f0f0f0;

                    &:last-child {
                        border-bottom: none;
                    }

                    .question {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 18px 16px;
                        font-size: 15px;
                        font-weight: 500;
                        color: #000;
                        cursor: pointer;

                        .arrow {
                            width: 28px;
                            height: 28px;
                            border-radius: 50%;
                            background: #f2f2f2;
                            position: relative;
                            transition: transform 0.3s;

                            &::before {
                                content: '';
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                width: 8px;
                                height: 8px;
                                border-right: 2px solid #000;
                                border-bottom: 2px solid #000;
                                transform: translate(-50%, -50%) rotate(45deg);
                            }
                        }
                    }

                    .answer {
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.3s ease;
                        padding: 0 16px;

                        p {
                            margin: 0;
                            padding: 0 0 16px;
                            font-size: 14px;
                            color: #777;
                            line-height: 1.6;
                        }
                    }

                    &.active {
                        .arrow {
                            transform: rotate(180deg);
                            background: #2f54eb;

                            &::before {
                                border-color: #fff;
                            }
                        }

                        .answer {
                            max-height: 200px;
                            /* 足够用即可 */
                        }
                    }
                }
            }
        }


        .h-bankuai {
            background-color: #000011;
            max-width: 1290px;
            margin: 0 auto;
            border-radius: 20px;

            .con {
                padding: 50px;
                position: relative;

                .sasi-heading {
                    text-align: left;
                    margin-bottom: 10px;

                    .sasi-heading__sub {
                        color: #fff;
                        background-color: #333333;
                        font-size: 16px;
                        padding: 12px 28px;
                        border: 1px solid #000011;
                        border-radius: 999px;
                        margin-bottom: 10px;
                        font-weight: 500;
                        display: inline-block;
                    }

                    .sasi-heading__title {
                        font-size: 36px;
                        color: #fff;
                        font-weight: 500;
                        margin-bottom: 0px;
                    }
                }

                .list {
                    padding: 15px;
                    display: flex;
                    flex-direction: column;
                    gap: 10px;

                    .item {
                        display: flex;
                        flex-direction: row;
                        gap: 15px;
                        align-items: center;

                        .img {
                            background-color: #333;
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .ps {
                            text-align: center;
                            color: #fff;
                            font-size: 16px;
                            margin-bottom: 0px;
                            font-weight: 500;
                        }
                    }
                }

                .btn-box {
                    display: flex;
                    justify-content: flex-start;
                    margin-top: 20px;

                    .btn {
                        background-color: #1e27f3;
                        color: #fff;
                        font-size: 16px;
                        padding: 16px 25px;
                        border-radius: 500px;
                        font-weight: 600;
                        cursor: pointer;
                    }
                }

                .img-db {
                    width: 322px;
                    margin-top: 0px;
                    position: absolute;
                    right: 0;
                    top: 0;
                    bottom: 0;
                    margin: auto;
                }
            }
        }
    }

    .page-box3 {
        width: 100%;
        max-width: 100%;
        background-color: #fff;
        padding: 50px 15px;
        margin: auto;

        .page-box3-con {
            max-width: 1290px;
            margin: auto;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
        }

        .logo {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin-bottom: 30px;

            img {
                width: 320px;
            }
        }

        .ps {
            color: #1a1a1c;
            font-size: 21px;
            text-align: left;
            margin-bottom: 20px;
        }

        .listicon {
            display: flex;
            gap: 10px;
            justify-content: center;
            margin-top: 0px;
            margin-bottom: 30px;

            .item {
                border: 1px solid #1e27f3;
                width: 45px;
                height: 45px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 17px;
                    height: 17px;
                }
            }
        }

        .appbox {
            display: flex;
            gap: 20px;
        }

        .itemapp {
            display: flex;
            justify-content: center;
            margin-bottom: 15px;

            img {
                width: 200px;
            }
        }

        .msgtxt {
            width: 300px;
            font-size: 14px;
            color: #808080;
            text-align: center;
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .alist {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            color: #1f27f3;
        }

        .bull {
            margin-top: 0px;
            text-align: center;
            color: #1a1a1c;
            font-size: 21px;
            margin-bottom: 10px;
            font-weight: 400;
        }

        .Bulls {
            text-align: center;
            margin-bottom: 10px;

            a {
                font-size: 14px;
                color: #808080;
            }
        }

        .heibox {
            max-width: 1290px;
            margin: 50px auto 0;
            background-color: #000011;
            padding: 50px 50px;
            border-radius: 20px;
            display: flex;
            flex-direction: row;
            gap: 15px;

            img {
                width: 220px;
            }
        }

        .imgaunll {
            display: inline-block;
            width: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 0px;
            margin-bottom: 0px;

            img {
                width: 180px;
                filter: grayscale(1);
            }
        }

        .imgs-box {
            max-width: 1290px;
            margin: 70px auto 50px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            img {
                width: 180px;
                filter: grayscale(1);
            }
        }

        .pnav {
            color: #808080;
            text-align: center;

            a {
                color: #808080;
                font-size: 14px;
            }
        }

    }

    .text-box {
        width: 100%;
        background-color: #f6f6f6;
        padding: 30px calc((100% - 1290px) / 2);
        text-align: left;
        font-size: 14px;
        color: #808080;
        line-height: 2;

        .ckgd {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            color: #1f2124;
            margin-top: 30px;

            i {
                font-size: 26px;
            }
        }

        .gdlist {
            margin-top: 20px;
            max-height: 0;
            overflow: hidden;
            transition: all 0.3s;

            &.active {
                max-height: 500px;
            }

            p {
                margin-bottom: 15px;
            }
        }
    }
}
</style>
<script setup name="loginPage">
import { initCrmChat } from '@/plugins/crmChat';
import { getTempService } from "@/api"
const value = ref(5)
const myswipe = ref(null)
const onChange = (index) => {
    myswipe.value.swipeTo(index - 1)
}
const activeIndex = ref(0) // 默认展开第一个

const list = [
    {
        q: '¿Abrir y mantener la cuenta tiene costo?																		',
        a: 'No. Apertura $0 y mantenimiento $0. Podés abrir hoy y empezar cuando quieras.'
    },
    {
        q: '¿Hay mínimos para empezar? 																		',
        a: 'No para abrir la Cuenta Inversión. Algunos instrumentos tienen mínimos propios del mercado; si querés empezar con poco, los Fondos Comunes a partir de mil pesos o hay acciones por menos de cien pesos.'
    },
    {
        q: '¿Puedo invertir en USA desde la misma cuenta?',
        a: 'Sí. Desde tu cuenta local operás acciones USA, ETFs y ADRs sin abrir otra plataforma.'
    },
    {
        q: '¿Cómo hago dólar MEP/CCL?',
        a: 'Tenés dos modos: Automático en un clic, donde nos encargamos de la operación, o Manual (paso a paso). Ambas requieren que el mercado esté abierto.'
    },
    {
        q: '¿Cuento con asesoramiento financiero?	',
        a: 'Sí, desde tu cuenta podés acceder a nuestro sistema de asesoramiento digital y te estaremos guiando a la mejor oportunidad de inversión para vos.'
    }
]

function toggle(index) {
    activeIndex.value = activeIndex.value === index ? null : index
}

// 更多
const gdActive = ref(false)

// 客服
let crm = null
let serverUrl = null
const initCrmChatFun = async (service) => {
    if (crm) {
        await crm.destroy()
    }
    crm = await initCrmChat(service);
}
const openService = () => {
    if (serverUrl) {
        openKf()
        return
    }
    getTempService().then(async res => {
        if (res.code == 200) {
            serverUrl = res.data
            openKf()
        }
    })
}
const openKf = async () => {
    try {
        if (!crm) {
            await initCrmChatFun(serverUrl)
        }
        crm.getCustomeServer();  // 打开客服聊天框
    } catch (err) {
        console.error('error', err);
    }
}
const destroyService = () => {
    if (crm) {
        crm.destroy()
        crm = null
    }
}

onBeforeUnmount(() => {
    destroyService()
})
</script>
